import React, {useEffect} from 'react';

const CheckBox = ({id, value, onChange, text=null, textInside=false}) => {
    //console.log('CheckBox ',id, value);
    return <div className='checkbox'>
        <div className='relative flex' onClick={() => onChange(id)}>
            <img src={'/images/checkbox.png'} className='checkbox-icon'  alt=''/>
            {textInside && <div className='check-text'>
                {text}
            </div>}
            {value===id && <div className='check-mark'>
                <img src={'/images/check-mark.png'} alt=''/>
            </div>}
        </div>

        {(text && !textInside) && <span className='checkbox-text'>{text}</span>}
    </div>;
};

export default CheckBox;